<!-- =========================================================================================
    File Name: inventory.vue
    Description: Inventory table
    ----------------------------------------------------------------------------------------
    Item Name: KOZO - VueJS Dashboard
    Author: BN
========================================================================================== -->

<template>
  <div>
    <!-- INVENTORY LIST -->
    <div id="ag-grid-demo">
      <vx-card>
        <div class="row mb-5 border-bottom">
          <div class="col-6 mx-auto">
            <!-- <vx-card lass="form-title mb-base border-right" title="Select Project"> -->
            <h4>Filter Inventory By Project</h4>
            <div class="row">
              <div class="col-8">
                <div>
                  <multiselect
                    v-model="project_value"
                    track-by="project_id"
                    label="project_name"
                    @input="
                      ({ project_id }) => (this.form.project_id = project_id)
                    "
                    :options="projects"
                    name="Project Name"
                    placeholder="Select Project"
                    :searchable="true"
                    :allow-empty="false"
                    open-direction="bottom"
                    deselect-label="Can't remove this value"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">{{
                      option.project_name
                    }}</template>
                  </multiselect>
                  <p class="error-msg">
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('Project Name')"
                      >{{ errors.first("Project Name") }}</span
                    >
                  </p>
                </div>
              </div>
              <div class="col-4">
                <vs-button
                  color="primary"
                  class="mx-auto hover-btn"
                  type="filled"
                  @click.prevent="searchExp"
                  >Search</vs-button
                >
              </div>
            </div>
          </div>
        </div>
        <!-- TABLE ACTION ROW -->
        <div class="flex flex-wrap justify-between items-center form-title">
          <h4 class>Inventory</h4>
          <div class="flex flex-wrap justify-end items-center">
            <!-- TABLE ACTION COL-2: SEARCH &amp; EXPORT AS CSV -->
            <div
              class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
            >
              <vs-input
                class="mb-4 md:mb-0 mr-4"
                v-model="searchQuery"
                @input="updateSearchQuery"
                placeholder="Search..."
              />
            </div>
          </div>
        </div>
        <ag-grid-vue
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowClicked="onRowDataChanged"
          :rowData="tempData"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="false"
          :paginationPageSize="paginationPageSize"
          :pagination="true"
          :suppressPaginationPanel="true"
        ></ag-grid-vue>
        <vs-pagination
          :total="totalPages"
          :max="maxPageNumbers"
          v-model="currentPage"
        />
      </vx-card>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { BASEURL } from "@/config/index.js";
import contacts from "../../ui-elements/ag-grid-table/data.json";
import DatetimePickerStartEnd from "@/views/components/extra-components/datetime-picker/DatetimePickerStartEnd.vue";
import ProjectService from "@/services/projectService.js";
import InventoryService from "@/services/inventoryService.js";
import deleteInventory from "./deleteInventory.vue";
import editInventory from "./editInventory.vue";
import viewExpImg from "./viewExpImg.vue";
import moveToInventory from "./moveToInventory.vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import Datepicker from "vuejs-datepicker";
import PermissionVariables from "@/services/UserManagementVaraibles.js";

export default {
  components: {
    Datepicker,
    AgGridVue,
    DatetimePickerStartEnd,
    "switch-component": {
      template: `<span>KOZO</span>`
    }
  },
  props: ["listType"],
  data() {
    return {
      permissionPageAccessArry: window.localStorage.getItem(
        "permissionPageAccess"
      )
        ? localStorage.getItem("permissionPageAccess").split(",")
        : "",
      loginUserRole: window.localStorage.getItem("UserRole"),
      excelurl: BASEURL,
      overlayLoadingTemplate: null,
      User: "Select User",
      totalPages: 0,
      searchQuery: "",
      isProjectSelect: "",
      gridOptions: {},
      maxPageNumbers: 7,
      form: {
        project_id: null
      },
      projects: [],
      tempData: [],
      project_value: [],
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      fromDate: null,
      toDate: null,
      configFromdateTimePicker: {
        minDate: new Date(),
        maxDate: null
      },
      configTodateTimePicker: {
        minDate: null
      },
      contacts: contacts,
      columnDefs: []
    };
  },
  beforeMount() {
    eventBus.$on("refreshInvenoryTable", e => {
      this.getAllTempDataList(this.currentPage);
    });
    this.columnDefs = [
      {
        headerName: "Name",
        field: "expense_name",
        filter: false,
        width: 200,
        suppressSizeToFit: true
      },
      {
        headerName: "Category",
        field: "category_name",
        filter: false,
        minWidth: 300
      },
      {
        headerName: "Number of Qty.",
        field: "quantity",
        filter: false,
        width: 200
      },
      {
        headerName: "Location Name",
        field: "city_name",
        filter: false,
        width: 200,
        sortable: false
      },
      {
        headerName: "Edit",
        field: "inventory_id",
        filter: false,
        width: 150,
        cellRendererFramework: editInventory
      },
      {
        headerName: "Images",
        field: "inventory_id",
        filter: false,
        width: 150,
        cellRendererFramework: viewExpImg
      },
      {
        headerName: "Delete",
        field: "inventory_id",
        filter: false,
        sortable: false,
        width: 150,
        cellRendererFramework: deleteInventory
      },
      {
        headerName: "Move to Inventory",
        field: "inventory_id",
        filter: false,
        width: 200,
        minWidth: 200,
        sortable: false,
        cellRendererFramework: moveToInventory
      }
    ];
    // this.setColums();
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("email", null);
      } else this.gridOptions.columnApi.setColumnPinned("email", "left");
    }
  },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 100;
    },
    // totalPages() {
    //   if (this.gridApi) return this.gridApi.paginationGetTotalPages();
    //   else return 0;
    // },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        if (val) {
          if (this.isProjectSelect > 0) {
            this.getAllTempDataList(val);
            return val;
          }
        } else return 1;
      }
    }
  },
  methods: {
    onRowDataChanged(e) {
      console.log("e :", e);
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },

    getAllTempDataList: function(currentPage) {
      let filters = {
        page: currentPage
      };
      let id = this.project_value.project_id;
      InventoryService.getAllTempInventory(filters, id)
        .then(response => {
          console.log("response :", response);
          const { data } = response;
          if (data && data.Status) {
            this.tempData = data.data;
            this.totalPages = data.pagination.last_page;
            // this.gridApi.sizeColumnsToFit();
          } else {
            this.$vs.notify({
              title: "Data Not Found",
              iconPack: "feather",
              icon: "check_box",
              color: "warning"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    getProjectsList: function() {
      ProjectService.getAllProjects()
        .then(response => {
          const { data } = response;
          if (data.Status) {
            if (
              !this.permissionPageAccessArry.includes(
                PermissionVariables.ViewOrganizationProjects
              ) &&
              this.loginUserRole != "Admin"
            ) {
              data.data.map(x => {
                if (
                  this.permissionPageAccessArry.includes("20P" + x.project_id)
                ) {
                  this.projects.push(x);
                }
              });
            } else {
              this.projects = data.data;
            }
          } else {
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    searchExp: function() {
      this.isProjectSelect = Object.keys(this.project_value).length;
      // GET TEMP DATA API
      if (this.isProjectSelect > 0) {
        this.getAllTempDataList(this.currentPage);
      } else {
        this.$vs.notify({
          title: "Select Project",
          iconPack: "feather",
          icon: "check_box",
          color: "warning"
        });
      }
    }
  },
  mounted() {
    // if (this.checkPermission(["department", "GET"])) {
    //   this.getProjectsList(this.currentPage);
    // }
    this.getProjectsList();
    this.gridApi = this.gridOptions.api;
  }
};
</script>
